import { useId, useState, useEffect } from 'react';
import Select from 'react-select';
import cleanFilename from './util.js';
import { Link } from 'react-router-dom';
import BackButton from './BackButton.js';
import './index.css';



function Links(){
  const [name, setName] = useState('');
    const [amount, setAmount] = useState('');
    const [email, setEmail] = useState('');
    const [links, setLinks] = useState([]);
    const [rawSongs, setRawSongs] = useState([[]]);
    const [pickedSongs, setPickedSongs] = useState([]);
    const [subStatus, setSubStatus] = useState(null);
    const [needsSubscription, setNeedsSubscription] = useState(false);
    const [billingLoading, setBillingLoading] = useState(false);
    const nameId = useId();
    const amountId = useId();
    const emailId = useId();
    const songsLabelId = useId();

    async function refreshSubStatus(forEmail) {
      try{
        const statusRes = await fetch(`/subscription/status?email=${encodeURIComponent(forEmail)}`);
        if (statusRes.ok) {
          const statusData = await statusRes.json();
          setSubStatus(statusData);
        }
      } catch(err){console.error(err);}
    }

    // GET SONGS BASED ON EMAIL CHANGING
    useEffect(() => {
        if(!email){
          setSubStatus(null);
          return;
        } else {
          const timeout = setTimeout(async () => {
            try{
          const res = await fetch('/links/songs', {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              email
            })
          });
          const data = await res.json();
          const cleanSongs = data.songs.map(song => cleanFilename(song));
          setRawSongs(data.songs.map((raw, i) => ({raw, clean: cleanSongs[i]})));
          } catch(err){console.error(err);}
          await refreshSubStatus(email);
            }, 1000);
              return () => clearTimeout(timeout);
        }
    }, [email]);

    async function goToCheckout() {
      setBillingLoading(true);
      try {
        const res = await fetch('/subscription/checkout', {
          method: 'POST',
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (!res.ok || !data.url) throw new Error(data.msg || 'Failed to start checkout');
        window.location.href = data.url;
      } catch(err) {
        console.error(err);
        alert(err.message);
        setBillingLoading(false);
      }
    }

    async function goToBillingPortal() {
      setBillingLoading(true);
      try {
        const res = await fetch('/subscription/portal', {
          method: 'POST',
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({ email }),
        });
        const data = await res.json();
        if (!res.ok || !data.url) throw new Error(data.msg || 'Failed to open billing portal');
        window.location.href = data.url;
      } catch(err) {
        console.error(err);
        alert(err.message);
        setBillingLoading(false);
      }
    }

  // FUNCTION THAT SELECTS SONGS FROM UI
  const pickSongs = (selected) => {
    setPickedSongs(selected);
    console.log('songs selected');
   } 
   // FUNCTION THAT GETS DOWNLOAD LINK(S) OF SELECTED SONGS
    async function getLinks(){
        // frontend to display list of links after button click
        const rawSelected = pickedSongs.map(song => song.value); // get songs from frontend to send back for download
        try{
            const res = await fetch('/links/linc',
          {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              name,
              email,
              amount,
              song: rawSelected})
          });
            if (res.status === 402) {
              setNeedsSubscription(true);
              return;
            }
             if(!res.ok) throw new Error('Links didnt work');
                // get links
            const data = await res.json();
             if (data.exists) {
                alert(`The name "${data.name}" already exists! Choose a different one.`);
                return; // stop here
    }
            setNeedsSubscription(false);
            setLinks(Array.isArray(data.endpoint) ? data.endpoint : []);
            await refreshSubStatus(email);
        } catch(err) {console.error(err);}
    }
    return (
        <main className='page'>
          <div className='page-content'>
            <BackButton fallback='/' />
            <Link to='/juug' className='btn btn-secondary'>See your juugs</Link>

            <div className='card'>
              <h1>Get download links</h1>
              <form id='downloadForm' onSubmit={(e) => {e.preventDefault(); getLinks()}}>
                <div className='field'>
                  <label className='label' htmlFor={emailId}>Upload email</label>
                  <input
                    id={emailId}
                    className='input'
                    type='email'
                    autoComplete='email'
                    inputMode='email'
                    onChange={e => setEmail(e.target.value)}
                  />
                  <p className='help-text'>Enter your upload email to load your songs below.</p>
                  {subStatus && (
                    <p className='help-text'>
                      {subStatus.subscribed
                        ? 'Unlimited links (subscribed)'
                        : `${subStatus.remaining} of ${subStatus.freeLimit} free links remaining`}
                    </p>
                  )}
                </div>

                <div className='field'>
                  <span className='label' id={songsLabelId}>Pick songs</span>
                  {rawSongs.length > 0 && (
                    <Select
                      inputId={`${songsLabelId}-select`}
                      aria-labelledby={songsLabelId}
                      isMulti
                      options={rawSongs.map(song => ({value: song.raw, label: song.clean}))}
                      value={pickedSongs}
                      onChange={pickSongs}
                    />
                  )}
                </div>

                <div className='field'>
                  <label className='label' htmlFor={nameId}>Name your juug</label>
                  <input
                    id={nameId}
                    className='input'
                    type='text'
                    onChange={e => setName(e.target.value)}
                  />
                </div>

                <div className='field'>
                  <label className='label' htmlFor={amountId}>Amount of links</label>
                  <input
                    id={amountId}
                    className='input'
                    type='number'
                    inputMode='numeric'
                    min='1'
                    onChange={e => setAmount(e.target.value)}
                  />
                </div>

                <button type='submit' className='btn btn-primary'>Get links</button>
              </form>
            </div>

            {needsSubscription && (
              <div className='card'>
                <h2>Free links used up</h2>
                <p>You've used your {subStatus?.freeLimit ?? 5} free links. Subscribe for $5/month for unlimited links.</p>
                <button type='button' className='btn btn-primary' disabled={billingLoading} onClick={goToCheckout}>
                  {billingLoading ? 'Loading…' : 'Subscribe — $5/month'}
                </button>
              </div>
            )}

            {subStatus?.subscribed && (
              <button type='button' className='btn btn-secondary' disabled={billingLoading} onClick={goToBillingPortal}>
                {billingLoading ? 'Loading…' : 'Manage subscription'}
              </button>
            )}

            <section aria-label='Your download links'>
              {Array.isArray(links) && links.length > 0 ? (
                <ul className='list'>
                  {links.map((v, k) => (
                    <li key={k} className='list-item card'>
                      <a
                        href={`http://undergroundradio.us/musicv2/?token=${v}`}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        http://undergroundradio.us/musicv2/?token={v}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className='empty-state'>No links yet!</p>
              )}
            </section>
          </div>
        </main>
    )
}



export default Links;